import React from 'react';
import { Input } from 'antd';
import FormItem from '../FormItem/FormItem';
import { formConfig } from '../../../../config';

const { fieldNames } = formConfig;

const DocNameField = ({ form, required }) => {
  return (
    <FormItem label="Наименование">
      {form.getFieldDecorator(fieldNames.docName, {
        rules: [
          {
            required,
            message: 'Укажите тип документа',
          },
        ],
      })(<Input placeholder="Укажите наименование документа" />)}
    </FormItem>
  );
};

export default DocNameField;
